import React from 'react'
import PropTypes from 'prop-types'
import { Container, Grid, Segment, Image } from 'semantic-ui-react'

const propTypes = {
  activePage: PropTypes.object.isRequired
}

const PageMainHeader = props => {
  // const { activePage } = props
  // const { label, subTitle } = activePage
  return (
    <Segment clearing basic id="page-header-segment">
      <Container>
        <Grid divided inverted stackable>
          <Grid.Row >
          <Image src="/img/logo-cvetek.png" centered /></Grid.Row >
        </Grid>
      </Container>
    </Segment>
  )
}

PageMainHeader.propTypes = propTypes
export default PageMainHeader



// WEBPACK FOOTER //
// ./src/components/PageMainHeader.js